import { FooterText } from "./FooterText";
import { SectionCard } from "./SectionCard";

const BlackFridayTermsAndConditions = () => {
  return (
    <div className="container my-4 px-3" style={{ textAlign: "justify" }}>
      <header className="pb-3 mb-4 text-center">
        <h2 className="card-title text-primary fw-bolder">
          TERMS AND CONDITIONS – BLACK FRIDAY CAMPAIGN
        </h2>
        <p className="text-muted mt-2">
          Please read the terms below to learn more about the Black Friday
          Campaign.
        </p>
      </header>

      <div>
        <SectionCard
          title="1. Eligibility and Participation"
          items={[
            "1.1 To participate in this cashback campaign, you must maintain an active Kegow wallet.",
            "1.2 Your Kegow wallet must be funded with sufficient balance to complete purchases of Value Added Services (VAS).",
            "1.3 Participation in this campaign is voluntary and constitutes acceptance of these Terms and Conditions in their entirety.",
          ]}
        />

        <SectionCard
          title="2. Qualifying Services"
          customContent={
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                2.1 This cashback campaign applies exclusively to purchases of
                Value Added Services (VAS) made through the Kegow application.
              </li>

              <li className="mb-2" id="section-2.2">
                2.2 For the purposes of this campaign, "VAS" shall be defined as
                and limited to the following services:
                <ul className="mt-2 ms-4" style={{ listStyle: "disc" }}>
                  <li className="mb-1">Airtime top-up services</li>
                  <li className="mb-1">Data bundle purchases</li>
                  <li className="mb-1">
                    Cable television subscription payments
                  </li>
                  <li className="mb-1">
                    Electricity bill payments and token purchases
                  </li>
                </ul>
              </li>

              <li className="mb-2">
                2.3 Any purchases outside of the services explicitly listed in{" "}
                <a
                  href="#section-2.2"
                  className="text-decoration-none fw-bolder"
                >
                  Section 2.2
                </a>{" "}
                shall not qualify for cashback under this campaign.
              </li>
            </ul>
          }
        />

        <SectionCard
          title="3. Cashback Calculation and Crediting"
          items={[
            "3.1 Eligible participants shall receive a cashback equivalent to ten percent (10%) of the transaction value on qualifying VAS purchases.",
            "3.2 Cashback shall be calculated based on the actual amount paid for the VAS purchase, excluding any fees, charges, or taxes.",
            "3.3 All cashback amounts earned under this campaign shall be credited directly to the participant's Commission Wallet within a reasonable timeframe following the qualifying transaction.",
            "3.4 Kegow shall not be liable for any delays in crediting cashback due to technical issues, system maintenance, or circumstances beyond its reasonable control.",
          ]}
        />

        <SectionCard
          title="4. Cashback Limitations"
          items={[
            "4.1 Each registered user account shall be eligible to receive cashback only once during the entire campaign period.",
            "4.2 The one-time cashback eligibility applies to the first qualifying VAS purchase made by the user during the campaign period.",
            "4.3 All subsequent VAS purchases made by the same user during the campaign period, regardless of the service type or transaction amount, shall not qualify for additional cashback.",
            "4.4 Multiple accounts created by the same individual or entity for the purpose of claiming multiple cashback rewards shall be considered a violation of these Terms and Conditions.",
          ]}
        />

        <SectionCard
          title="5. Commission Wallet Usage and Restrictions"
          items={[
            "5.1 All cashback credited under this campaign shall be deposited into the participant's Commission Wallet and shall not be transferable to any other wallet type or external account.",
            "5.2 Funds held in the Commission Wallet may only be utilized for the purchase of Value Added Services (VAS) as defined in Section 2.2 of these Terms and Conditions.",
            "5.3 The Commission Wallet balance cannot be withdrawn as cash or transferred to any bank account or third-party payment service.",
            "5.4 Purchases of VAS made using funds from the Commission Wallet shall not qualify for additional cashback under this or any other campaign.",
            "5.5 Commission Wallet funds shall not expire, provided the participant's account remains active and in good standing.",
          ]}
        />

        <SectionCard
          title="6. Campaign Modifications and Termination"
          items={[
            "6.1 Kegow reserves the absolute right to modify, suspend, or terminate this cashback campaign at any time, with or without prior notice to participants.",
            "6.2 Any modifications to these Terms and Conditions shall be communicated through the Kegow platform, and continued participation in the campaign following such modifications shall constitute acceptance of the revised terms.",
            "6.3 In the event of campaign termination, Kegow shall honor all cashback amounts that have been earned and credited prior to the termination date.",
          ]}
        />

        <SectionCard
          title="7. General Provisions"
          items={[
            "7.1 These Terms and Conditions constitute the entire agreement between Kegow and the participant with respect to this cashback campaign.",
            "7.2 Kegow's failure to enforce any provision of these Terms and Conditions shall not constitute a waiver of that provision or any other provision.",
            "7.3 If any provision of these Terms and Conditions is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.",
            "7.4 These Terms and Conditions shall be governed by and construed in accordance with the applicable laws of the jurisdiction in which Kegow operates.",
            "7.5 By participating in this campaign, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.",
          ]}
        />

        <FooterText
          supportText="  For further information, inquiries, or customer support regarding
            this cashback campaign, please contact Kegow customer service
            through the official channels provided on the app."
          termsText="This Black Friday cashback campaign is valid from 28/11/2025 to
              30/11/2025. Kegow reserves the right to request additional
              verification from participants, revoke cashback awarded in cases
              of refund or reversal, and restrict cashback in cases of suspected
              fraud or abuse. This offer cannot be combined with other
              promotions. Participation constitutes acceptance of these Terms
              and Conditions."
        />
      </div>
    </div>
  );
};

export default BlackFridayTermsAndConditions;
